export const EXPIRE_CAPTCHA = "application/captcha/EXPIRE_CAPTCHA";

export default function expireCaptcha() {
  return {
    "payload": null,
    "type": EXPIRE_CAPTCHA
  };
}
